import React from 'react';   
import { Document, Page, Text, View, StyleSheet, PDFViewer, Image, Link, Font } from '@react-pdf/renderer';
import logo from '../../assets/img/pdf/logo.png'; 
import signbohouse from '../../assets/img/sign-bo-house.png'; 
import firebase from './../../firebase';


import Handlee from './../../assets/fonts/Handlee/Handlee-Regular.ttf';
import Cormorant from './../../assets/fonts/Cormorant_Garamond/CormorantGaramond-Light.ttf';
import moment from 'moment';

Font.register({
    family: 'Handlee',
    format: "truetype",
    src: Handlee
  });

  Font.register({
    family: 'Cormorant',
    format: "truetype",
    src: Cormorant
  });

const ContractPDF= ({contract}) => { 


    const [villas, setVilla] =  React.useState([]);

    const [clients, setClients] = React.useState([]);
    const [l, setL] = React.useState(false);  
    const [dataClient, setDataClient] =  React.useState({});

    const [checkIn, setCheckIn] = React.useState(new Date());
    const [checkOut, setCheckOut] = React.useState(new Date()); 
// Create styles
    const styles = StyleSheet.create({
    pageHome: {
      flexDirection: 'row',
      backgroundColor: 'white',
    },
    view:{
  
      flexGrow: 1
    },
    section: {
      margin: 20,
      padding: 10,
      flexGrow: 1
    }, image:{ 
    },textd: { 
      fontSize: 16,   color:"black" , textAlign:"center",
    },
    text:{
      fontSize:10
    },
    title:{
      fontSize:12
    },
    titlen:{
      fontSize:12,
      color:'#5e5e5e'
    },
    texten:{
      fontSize:10,
      color:'#5e5e5e'
    },
    table:{
      // borderWidth:1,
      // borderStyle:'solid',
      // borderColor:'grey',
    },
    m:{
      // fontSize:11, 
      padding:4,
    },tablel : {  
      borderRight: '1px solid #d5d5d5'
    },
    wt: {
      width: 100
    }
    });


    const getVilla = (ls) => { 
        let d = {};
        villas.forEach(e => {
            if (ls === e.value){ 
                d = e;
            }
        })
        return d;
      }
      const getClients = () => {
        // get list clients and format
        firebase.firestore().collection('crm').get().then((snap)=> {
            let s = [];
            snap.forEach((d) => { 
                let e = '';
                let pre = d.data()?.email?.split(',') || []
                pre.forEach((s) =>{
                    e += `${s}, `;
                })
              const dr = {value : d.id, label: `${d.data()?.gender === 'male' ? 'Monsieur' : 'Madame'} ${d.data()?.lastName} ${d.data()?.firstName}`, data: d.data(), signature: `${d.data()?.lastName} ${d.data()?.firstName}` }
              if (d.data()?.delete){}
              else{
                s.push(dr)
              }
            }) 
            setClients(s)
            s?.forEach(c => { 
                if (c.value === contract.client.value){
                    setDataClient(c);
                }
            })

          }).catch((error) => {
            setL(false); 
            var errorMessage = error.message;
            toast.error(errorMessage);
          })

    }

    function gDate() {
        function getPeriodBetweenDates(date1, date2) {
            // Parse the input strings as dates
            const startDate = new Date(date1);
            const endDate = new Date(date2);
        
            // Calculate the difference in milliseconds
            const timeDifference = endDate - startDate;
        
            // Convert the difference to days
            const daysDifference = timeDifference / (1000 * 60 * 60 * 24);
        
            return daysDifference;
        }
        
        // Example usage
        const date1 = checkIn;
        const date2 = checkOut;
        
        const period = getPeriodBetweenDates(date1, date2);
        // console.log(`The period between ${date1} and ${date2} is ${period} days.`);
        return `${period} Nuit${period > 1 ? 's' : ''}`;
    }

      const loadVilla = () => { 
        firebase.firestore().collection('properties').get().then((snap)=> {
          let s = [];
          snap.forEach((d) => {
            var l = d.data(); 
            if (l?.delete){
              // supprimer donc ne pas affiché
            }else{ 
                const dr = {value : d.id, label: `${l?.nameHouse}`, data: l  }
                s.push(dr) 
            }
            
          })
          setVilla(s); 
        }).catch((error) => {
          setL(false); 
          var errorMessage = error.message;
          toast.error(errorMessage);
        })
      } 
      const getUser = (is) => {
        let d = {};
        clients.forEach(element => {
            if (is === element.value){
                d = element;
            }
        });
        return d;
      }


      function isValidDate(dateString) {
        // Attempt to create a Date object from the input string
        var date = new Date(dateString);
    
        // Check if the date is valid
        // "Invalid Date" is the string returned by Date object for an invalid date
        // Also, make sure the input string is not equal to the default date (1970-01-01)
        return date.toString() !== 'Invalid Date' && !isNaN(date);
    }
    

    React.useEffect(() =>{
        if (contract)  {
            getClients();
            loadVilla();   
            // console.log("contract", contract)
            setCheckIn(isValidDate(contract?.checkin) ? contract?.checkin : contract?.checkin.toDate()) 
            setCheckOut(isValidDate(contract?.checkout) ? contract?.checkout : contract?.checkout.toDate())
        } 
    },[contract])

    const NbPage = ({nb, top=70}) => { 
        return <View>
            <Text style={{position: 'absolute', bottom: top, right: 0, backgroundColor:'black', color:'white', padding:5, fontSize:10}}>{nb}</Text>
            {contract && contract?.sign && (<View style={{position: 'absolute', bottom: top - 60, right: 0,}} >
                    <Text style={{textAlign:'right', paddingRight:30, fontFamily:'Handlee'}}>{contract?.client?.label.charAt(0)+contract?.client?.label.split(' ')[1]?.charAt(0)}</Text>
                    {contract?.sign?.bohouse && <Text style={{textAlign:'right', paddingRight:30, marginBottom:30, fontFamily:'Handlee'}}>AT</Text>}
            </View>)
            }
        </View>
    }

    function hDate() {
        function formatDateRange(date1, date2) {
            const options = {   day: '2-digit', month: 'short', year: 'numeric' };
            const options2 = {   day: '2-digit', month: 'short', year: 'numeric' };
            
            const formattedDate1 = new Date(date1).toLocaleDateString('fr-FR', options);
            const formattedDate2 = new Date(date2).toLocaleDateString('fr-FR', options2);
        
            return `Du ${formattedDate1} au ${formattedDate2}`;
        }
        
        // Example usage
        const date1 = checkIn;
        const date2 = checkOut;
        
        const formattedDateRange = formatDateRange(date1, date2); 
        return formattedDateRange;
    }
    function pDate(){ 
        const options = {day: '2-digit', month: 'long', year: 'numeric' };
             
        const formattedDate1 = new Date(checkIn).toLocaleDateString('fr-FR', options);
        return formattedDate1; 
    }
    
    const Ligne = ({fr, en, info, bg=false, bt=false, t=1, textAlign='left', whitef=false}) => {
        return (
            <View style={[styles.table, {  display:'flex', flexDirection:'row', backgroundColor:bg ? whitef ? 'transparent': '#f5f5f5': 'transparent', borderBottom: bg ? '0px':'1px solid #d5d5d5', borderTop: bt ? '1px solid #d5d5d5':'0px'}]}>
                <Text style={[styles.wt,styles.tablel,styles.text,styles.m, {width: en === null ? '50%' : t == 2 ? '33%': t == 4 ? '16.5%' : 100, textAlign: en === null ? 'center' : 'left', fontSize: en === null ? 12 : 11}]}>{fr}</Text>
                {en !== null && (<Text style={[styles.wt,styles.tablel,styles.texten,styles.m, {width:t == 2 ? '33%': t == 4 ? '16.5%' : 100}]}>{en}</Text>)}
                <Text style={[styles.text,styles.m, { textAlign:textAlign , flex:1} ]}>{info}</Text>
            </View>
        )
    }

    // Create Document Component
  const MyDocument = () => (
    <Document>
        <Page size="A4" style={styles.pageHome} > 
            <View style={styles.view} >
                <Image style={ { width: 100, marginLeft:'auto', marginRight:'auto'}} src={logo} />
                <View style={styles.section}>
                    <Text style={[styles.textd, {fontFamily:'Cormorant'}]}>CONTRAT DE LOCATION SAISONNIÈRE</Text>
                    <Text style={[styles.textd, {color:'#5e5e5e',fontFamily:'Cormorant'}]}>SEASONAL RENTAL CONTRACT</Text>;

                    <View style={styles.section}>
                        <Text style={styles.text}>
                        Entre les soussignés, ci-après dénommé « le bailleur » d'une part
                        </Text>
                        <Text style={styles.texten}>
                        Between the undersigned, hereby described "the lessor" on one hand
                        </Text>
                        <View style={{marginTop:10}}/>
                        
                        <View style={{border:'1px solid #d5d5d5'}}>
                            <Ligne fr={'NOM'} en={'NAME'} info={'Bo-House'} />
                            <Ligne fr={'ADRESSE'} en={'LOCATION'} info={'4 rue Parc des Lices, Bat. 4, Traverse de la Matelotte'} bg={true} />
                            <Ligne fr={'VILLE'} en={'CITY'} info={'Saint-Tropez'} bt={true}/>
                            <Ligne fr={'CODE POSTAL'} en={'ZIP CODE'} info={'83990'} bg={true}/>
                            <Ligne fr={'PAYS'} en={'COUNTRY'} info={'France'} bt={true}/>
                            <Ligne fr={'TÉLÉPHONE'} en={'PHONE'} info={contract?.interlocuteur?.phone || '--'} bg={true}/>
                            <Ligne fr={'E-MAIL'} en={'MAIL'} info={contract?.interlocuteur?.email || '--'} bt={true}/>
                            <Ligne fr={'GÉRANT'} en={'MANAGER'} info={'Antony Tardieu'} bg={true}/>
                        </View>
                        <View style={{marginTop:50}}/>
                        <Text style={styles.text}>
                        Ci-après dénommé « le preneur » d’autre part
                        </Text>
                        <Text style={styles.texten}>
                        Hereby described "the tenant" on the other hand
                        </Text>
                        <View style={{border:'1px solid #d5d5d5', marginTop:10}}>
                            {dataClient.data?.type === "moral" ? (<>
                                <Ligne fr={'NOM DE LA SOCIETE'} en={'NAME OF THE COMPANY'} info={`${dataClient.data?.businessName}`} bg={true} />
                                <Ligne fr={'REPRESENTE PAR'} en={'REPRESENTED BY'} info={`${dataClient.data?.representBy}`} bt={true} />
                            
                            </>): (
                                <Ligne fr={'NOM'} en={'NAME'} info={`${getUser(contract?.client?.value)?.label}`} />
                            
                            )}
                            <Ligne fr={'ADRESSE'} en={'LOCATION'} info={dataClient.data?.type === "moral" ? dataClient.data?.businessAdresse || '' : getUser(contract?.client?.value).data?.adresse} bg={true} />
                            <Ligne fr={'VILLE'} en={'CITY'} info={dataClient.data?.type === "moral" ? dataClient.data?.businessCity != undefined && dataClient.data?.businessCity || '' + ' '+ dataClient.data?.businessZipcode !== undefined && dataClient.data?.businessZipcode  || '' : getUser(contract?.client?.value).data?.city} bt={true}/>
                            <Ligne fr={'PAYS'} en={'COUNTRY'} info={dataClient.data?.type === "moral" ? dataClient.data?.businessCountry || '' :getUser(contract?.client?.value).data?.country} bg={true}/>
                        </View>
                    </View>
                </View>
                <NbPage nb={'1/9'} top={120} />
                <View style={{ backgroundColor:'black', width: '100%', padding: '20px 40px'}}>
                    <Text style={{color:'white', fontSize:10, paddingLeft:20}}>BO-HOUSE Société par actions simplifiée - Capital social 10.000,00€</Text>
                    <Text style={{color:'white', fontSize:10, paddingLeft:20}}>R.C.S. de Fréjus n°828 073 593 - CPI : 83042017000020518 VAR</Text>
                </View>
            </View>
        </Page>
        <Page size="A4" style={styles.pageHome} > 
            <View style={styles.view} >
                <Image style={ { width: 100, marginLeft:'auto', marginRight:'auto'}} src={logo} />
                <View style={styles.section}>
                    <View style={styles.section}>
                        <Text style={styles.text}>
                        Il a été convenu une location saisonnière sur le bien suivant, et aux conditions suivantes
                        </Text>
                        <Text style={styles.texten}>
                        It has been agreed to a seasonal rent for the following property, and to the following conditions
                        </Text>
                
                        <View style={{marginTop:10}}/>
                        <View style={{border:'1px solid #d5d5d5' }}>
                            <Ligne fr={'ADRESSE'} en={'LOCATION'} info={`${getVilla(contract?.property?.value)?.label} ${getVilla(contract?.property?.value)?.data?.adresse}`} t={4}/>
                            <Ligne fr={'VILLE'} en={'VILLE'} info={`${getVilla(contract?.property?.value)?.data?.city} (${getVilla(contract?.property?.value)?.data?.zipcode})`} t={4} bg={true} />
                            <Ligne fr={'PAYS'} en={'COUNTRY'} info={'France'}  t={4} bt={true}/> 
                            <Ligne fr={'DATES'} en={'DATES'} info={hDate()} bg={true} t={2} textAlign={'right'}/>
                            <Ligne fr={'DURÉE en nuits'} en={'LENGHT in nights'} info={gDate()} bt={true} t={2}  textAlign={'right'}/> 
                            <Ligne fr={'LOYER frais d’agence inclus'} en={'RENTAL including agency fee'} info={`${contract?.fraisagence || "---"} €`} t={2} bg={true} textAlign={'right'} />
                            <Ligne fr={'ACOMPTE'} en={'DEPOSIT'} info={`${contract?.deposit || "---"} €`} t={2} textAlign={'right'}  bt={true}/>
                            <Ligne fr={'CAUTION'} en={'SECURITY'} info={`${contract?.security || "---"} €`} t={2} bg={true} textAlign={'right'} />
                            <Ligne fr={'MÉNAGE de fin de séjour'} en={'CLEANING services at departure'} info={`${contract?.menage || "---"} €`} t={2} textAlign={'right'}  bt={true}/>
                            <Ligne fr={'TAXE DE SÉJOUR'} en={'TOURIST TAX'} info={`${contract?.tax ? contract?.tax  : '6,62€/jour/Personne de + de 13 ans' }`} t={2} bg={true} textAlign={'right'} />
                            <Ligne fr={'FRAIS D’HUISSIER'} en={'BAILIFF\'S FEES'} info={`${contract?.baififf || "---"} €`} t={2} textAlign={'right'}  bt={true}/>
                            <Ligne fr={'TOTAL (EURO)'} en={null} info={`${Number(contract?.total_pay) - Number(contract?.deposit || 0) - Number(contract?.security || 0) } €`} t={2} bg={true}   whitef={true} textAlign={'right'} />
                        </View>
                        <View style={{marginTop:10}}/>

                        {contract?.clauseaccompte ? (<>
                            <Text style={styles.title}>
                            VERSEMENT DE L’ACOMPTE
                            </Text>
                            <Text style={styles.titlen}>
                            FIRST PART OF PAYMENT
                            </Text>
                            <View style={{marginTop:10}}/>
                            <Text style={styles.text}>Le PRENEUR versera au BAILLEUR la somme de {contract?.deposit || '---'} € d’acompte (25%) à la signature du présent contrat, le solde de la location ({contract?.total_pay || '---'} € ) et la caution remboursable ({contract?.security || '---'} € ) au plus tard 30 jours avant le début de la location, soit pour le {pDate()}.</Text>
                            <Text style={styles.texten}>The TENANT shall pay the LESSOR the sum of {contract?.deposit || '---'} € deposit (25%) at the signature of the present contract, the balance of the rental ({contract?.total_pay || '---'} € ) and the refundable deposit ({contract?.security || '---'} € ) at the latest 30 days before the beginning of the rental period, that is to say for the {pDate()}.</Text>

                        </>) : (
                            <>
                            <Text style={styles.title}>
                            PAIEMENT : A la signature du contrat
                            </Text>
                            <Text style={styles.titlen}>
                            PAYMENT: At the signature of the contract
                            </Text>
                            </>
                        )}
                        
                        <View style={{marginTop:10}}/>
                        <Text style={styles.title}>
                        ENGAGEMENTS MUTUELS
                        </Text>
                        <Text style={styles.titlen}>
                        MUTUALS ENGAGEMENTS
                        </Text>
                        <View style={{marginTop:10}}/>
                        <Text style={styles.text}><Text style={{fontSize:20}}>L</Text><Text style={{fontSize:13}}>e PRENEUR</Text> versera entre les mains du BAILLEUR, le dépôt de garantie lors du versement du solde de la location et ce à titre de condition essentielle et déterminante de son consentement sans laquelle il n’aurait pas signé les présentes.</Text>
                        <Text style={styles.text}><Text style={{fontSize:20}}>L</Text><Text style={{fontSize:13}}>e BAILLEUR</Text> s’engage dans les trente jours suivant la restitution des clés par le PRENEUR, à rembourser celui-ci, sauf justes motifs (notamment déduction des sommes dues par le PRENEUR au titre des charges et des réparations locatives, s’il y a lieu). Si le montant du dépôt de garantie n’est suffisant, le PRENEUR s’engage à parfaire la somme.</Text>
                        
                    </View>
                </View>
                <NbPage nb={'2/9'} />
            </View>
        </Page>

        <Page size="A4" style={styles.pageHome} > 
            <View style={styles.view} >
                <Image style={ { width: 100, marginLeft:'auto', marginRight:'auto'}} src={logo} />
                <View style={styles.section}>
                    <View style={styles.section}>
                        <Text style={styles.texten}><Text style={{fontSize:20}}>T</Text><Text style={{fontSize:13}}>he TENANT</Text> will pay the deposit with the payment of the rental balance, and it, as essential and determinating condition of its consent without which he would not have signed the present contract.</Text>
                        <Text style={styles.texten}><Text style={{fontSize:20}}>T</Text><Text style={{fontSize:13}}>he LESSOR</Text> makes a commitment in thirty days following the return of keys by the TENANT, to pay off this one, except right motives (in particular deduction of the sums owed by the TENANT in conformance with loads and renting repairs, if necessary). If the amount of the deposit is not sufficient, the TENANT makes a commitment to perfect the sum.</Text>
                        <View style={{marginTop:10}}/>
                        <Text style={styles.title}>
                        USAGE
                        </Text>
                        <Text style={styles.titlen}>
                        USE
                        </Text>
                        <View style={{marginTop:10}}/>
                        <Text style={styles.text}>
                        La présente location meublée temporaire est soumise au Code Civil Français et aux présentes
                        stipulations qui conformément aux usages permettent d’y déroger. La présente location meublée
                        temporaire est à usage de résidence secondaire, donc à usage exclusif d’habitation. Les Biens dont il
                        s’agit sont à usage d’habitation <Text style={{backgroundColor:'black', color:'white'}}>pour un maximum de {getVilla(contract?.property?.value)?.data?.maxGuest || "--"} personnes</Text>, y compris le personnel. Le non-respect
                        des Biens ou du personnel peut occasionner l’expulsion immédiate du client PRENEUR. Les heures
                        d'entrées dans la location se font entre 16h et 20h, les heures de sortie entre 9h et 10h. Sont compris :
                        </Text>
                        <Text style={styles.text}>• électricité,</Text>
                        <Text style={styles.text}>• eau,</Text>
                        <Text style={styles.text}>• linge de maison (draps et serviettes)</Text>
                        {contract?.servicefr?.length > 0 && contract?.servicefr?.split("\n").map(line => {
                            return (<Text style={styles.text}>• {line?.trim()}</Text>)
                        })}
 
                        <View style={{marginTop:10}}/>
                        <Text style={styles.texten}>
                        The present temporary furnished rent is subjected to the French Civil Code and to the present
                        conditions which in accordance with custom allow to break it. The present temporary furnished rent is
                        for use of holiday home, thus for exclusive use of house. The property in question is residential <Text style={{backgroundColor:'#5e5e5e', color:'white'}}>for a maximum of {getVilla(contract?.property?.value)?.data?.maxGuest || "--"} people</Text>, including staff. Failure to respect property or staff may result in the immediate
                        eviction of the TENANT. The check-in is between 5 pm and 8 pm, the check-out is between 9 am and 10
                        am. Are included:
                        </Text>
                        <Text style={styles.texten}>• electricity,</Text>
                        <Text style={styles.texten}>• water,</Text>
                        <Text style={styles.texten}>• household linen (sheets and towels)
                        </Text>
                        {contract?.serviceEn?.length > 0 && contract?.serviceEn?.split("\n").map(line => {
                            return (<Text style={styles.texten}>• {line?.trim()}</Text>)
                        })}
                    
                        <View style={{marginTop:10}}/>
                        <Text style={styles.text}>
                            Sont annexés au présent contrat :
                        </Text> 
                        <Text style={styles.text}>
                        • les conditions générales de location, dont un exemplaire à retourner signé </Text> 
                        <Text style={styles.text}>• le descriptif des lieux loués.
                        </Text>
                        <Text style={styles.texten}>
                            Are annexed to the present contract:
                        </Text> 
                        <Text style={styles.texten}>
                        • the general conditions of rent, of which a copy to be turned signed,</Text> 
                        <Text style={styles.texten}>• the description of the rented places.
                        </Text> 
                        <View style={{marginTop:25}}/>
                        <View style={{width: '100%', height: 3, backgroundColor: 'black'}} />
                        <View style={{marginTop:25}}/>
                        <Text style={styles.text}>FAIT À SAINT-TROPEZ, <Text style={{backgroundColor:'black', color:'white'}}>LE {contract && contract?.sign ? moment(contract?.sign?.date?.toDate()).format('DD/MM/YYYY') : '--/--/----'}</Text></Text> 
                        <Text style={styles.text}>MADE AT SAINT-TROPEZ, <Text style={{backgroundColor:'#5e5e5e', color:'white'}}>ON THE {contract && contract?.sign ? moment(contract?.sign?.date?.toDate()).format('DD/MM/YYYY') : '--/--/----'}</Text></Text>
                    
                        <View style={{marginTop:30}}/>
                        <View style={{display:'flex', flexDirection:'row',}}>
                            <View style={{flex:1}}>
                                <Text style={[styles.text, {fontSize: 11}]}>LE PRENEUR</Text>
                                <Text style={[styles.texten, {fontSize: 11}]}>THE TENANT</Text>
                                <Text style={[styles.text, {fontSize: 11}]}>« Lu et approuvé »</Text>
                                <Text style={[styles.texten, {fontSize: 11}]}>"Read and approved"</Text>
                                {contract && contract?.sign && (
                                     <Image style={ { width: 100, position:'absolute', bottom:-50}} src={contract?.sign?.bURL64} />
                                )}
                                <Text style={[styles.text, { paddingLeft: 100, paddingTop:10, position:'absolute',  bottom:-20}]}>{getUser(contract?.client?.value)?.signature}</Text>
                            </View>
                            <View style={{flex:1}}>
                                <Text style={[styles.text, {fontSize: 11}]}>LE BAILLEUR</Text>
                                <Text style={[styles.texten, {fontSize: 11}]}>THE LESSOR</Text>
                                <Text style={[styles.text, {fontSize: 11}]}>« Lu et approuvé »</Text>
                                <Text style={[styles.texten, {fontSize: 11}]}>"Read and approved"</Text>
                                {contract && contract?.sign && contract?.sign?.bohouse && (
                                    <Image style={ { width: 100, position:'absolute', bottom:-30}} src={signbohouse} />
                                
                                )}
                                <Text style={[styles.text, { paddingLeft: 100, paddingTop:10, position:'absolute',  bottom:-20}]}>Lu et approuvé</Text>
                            </View>
                        </View>
                    </View>
                </View> 
                <NbPage nb={'3/9'}  />
            </View>
        </Page>
        <Page size="A4" style={styles.pageHome} > 
            <View style={styles.view} >
                <Image style={ { width: 100, marginLeft:'auto', marginRight:'auto'}} src={logo} />
                <View style={styles.section}>
                    <Text style={[styles.textd,  {fontFamily:'Cormorant'}]}>CONDITIONS GÉNÉRALES</Text>
                    <Text style={[styles.textd, {color:'#5e5e5e', fontFamily:'Cormorant'}]}>GENERAL CONDITIONS</Text>
                    <View style={styles.section}> 
                        <Text style={styles.title}>
                        OBLIGATIONS DU BAILLEUR
                        </Text>
                        <Text style={styles.titlen}>
                        LESSOR OBLIGATIONS
                        </Text>
                        <View style={{marginTop:10}}/>
                        <Text style={styles.text}><Text style={{fontSize:20}}>L</Text><Text style={{fontSize:13}}>e BAILLEUR</Text> s’oblige à remettre au PRENEUR les locaux en parfait état d’entretien et de
                            fonctionnement, y compris la piscine et le jardin, conformément à l’état descriptif annexé. Le
                            BAILLEUR s’assure auprès du propriétaire que celui-ci garantit l’entretien de la piscine pendant toute la
                            location saisonnière ainsi qu’il respecte toutes les normes d’hygiène et de sécurité en la matière. Il
                            s’assure également que le propriétaire prend à sa charge l’entretien et l’arrosage du jardin pendant toute
                            la location saisonnière.
                        </Text>
                        <Text style={styles.texten}><Text style={{fontSize:20}}>T</Text><Text style={{fontSize:13}}>he LESSOR</Text> s’oblige à remettre au PRENEUR les locaux en parfait état d’entretien et de
                         obliges to put back to the TENANT places in perfect condition of maintenance and
                            functioning, including swimming pool and garden, in compliance with the annexed descriptive state.
                            The LESSOR ensures with the owner that he guarantees the maintenance of the swimming pool during
                            all the seasonal hiring as well as respecting all the standards of hygiene and safety in the matter. He also
                            ensures that the 
                        </Text>
                        <View style={{marginTop:10}}/>
                        <Text style={styles.text}>
                        <Text style={{fontSize:20}}>L</Text><Text style={{fontSize:13}}>es parties sont informées</Text> que la loi du 3 janvier 2003 et les décrets du 31 décembre 2003 et du 7
                            juin 2004 prévoient l’obligation d’équiper les piscines enterrées et de plein air d’un dispositif de
                            sécurité aux normes de l’article R 128-2 du Code de la construction et de l’habitation (barrières de
                            protection et moyen d’accès au bassin, système d’alarme, couverture de sécurité et dispositif
                            d’accrochage, abris de piscine). En l’espèce le BAILLEUR s’assure de l’installation d’un système d’alarme
                            conforme aux normes de sécurité en vigueur, précisant toutefois qu’un tel dispositif ne saurait remplacer
                            une vigilance constante. Le PRENEUR devra prendre connaissance des conditions de fonctionnement et
                            d’entretien du dispositif de sécurité installé et s’engage sous sa responsabilité exclusive à en respecter
                            les prescriptions d’utilisation.
                        </Text>
                        <Text style={styles.text}>
                        <Text style={{fontSize:20}}>T</Text><Text style={{fontSize:13}}>he parts are informed</Text> that the law of January 3rd, 2003 and the decrees of December 31st, 2003
                            and June 7th, 2004 plan the obligation to equip the buried and outdoor swimming pools of a safety
                            device in the standards of the article R 128-2 of the Code of the construction and the house (barriers of
                            protection and way of access to the pond, the alarm system, the cover of safety and device of collision,
                            Swimming pool enclosures). In the case in point, The LESSOR ensures the installation of an alarm system
                            in compliance with the current safety standards, specifying however that such a device could not replace
                            a constant vigilance. The TENANT will have to acquaint with conditions of functioning and maintenance
                            of the installed safety device and makes a commitment under its exclusive responsibility for respecting
                            the prescriptions of use.
                        </Text>
                        <View style={{marginTop:10}}/>
                        <Text style={styles.text}>
                            <Text style={{fontSize:11}}>Le BAILLEUR</Text> s’engage à ne pas entreprendre de travaux dans le bien loué ou ses abords immédiats pendant la période de location, exception faite des travaux à caractère urgent.
                            <Text style={styles.texten}><Text style={{fontSize:11}}>The LESSOR</Text> makes a commitment not to undertake works in the rented good or his immediate accesses during the period of rent, exception made of the works for urgent character.</Text>
                        </Text>

                    </View>
                </View>
                <NbPage nb={'4/9'} />
            </View>
        </Page>


        <Page size="A4" style={styles.pageHome} > 
            <View style={styles.view} >
                <Image style={ { width: 100, marginLeft:'auto', marginRight:'auto'}} src={logo} />
                <View style={styles.section}>
                    <View style={styles.section}> 
                        <Text style={styles.title}>
                        OBLIGATIONS DU PRENEUR
                        </Text>
                        <Text style={styles.titlen}>
                        TENANT OBLIGATIONS
                        </Text>
                        <View style={{marginTop:10}}/>
                        <Text style={[styles.text,{textDecoration: 'underline'}]}>Le PRENEUR reconnait :</Text>
                        

                        {contract?.visitebien === true ? (
                            <>
                            <Text style={styles.text}>Que le bien loué lui a été présenté par l’agence BO HOUSE et l’avoir visité en présence d’un représentant de l’agence.

                        </Text>
                        <View style={{marginTop:10}}/>
                        <Text style={[styles.texten,{textDecoration: 'underline'}]}>The TENANT acknowledges :</Text>
                        
                        <Text style={styles.texten}>That the rented property was presented to him by the BO HOUSE agency and that he visited it in the presence of a representative of the agency.
                        </Text>

                            </>
                        ): (

                            <>
                            <Text style={styles.text}>Que le bien loué lui a été présenté par l’agence BO HOUSE et avoir loué le bien sans l’avoir visité. Il
                            ne pourra se prévaloir de l’absence de visite à son arrivée dans les lieux. Le PRENEUR fait son affaire
                            personnel de la conformité du bien loué aves ses attentes personnelles et renonce à tous recours
                            contre le propriétaire et son mandataire.
                            </Text>
                            <View style={{marginTop:10}}/>
                            <Text style={[styles.texten,{textDecoration: 'underline'}]}>The TENANT acknowledges :</Text>
                            
                            <Text style={styles.texten}>That the rented property was presented to him by the BO HOUSE agency and that he rented the
                                property without having visited it. The LESSOR may not claim that the property was not visited on
                                arrival. The TENANT is personally responsible for the conformity of the rented property with his
                                personal expectations and waives all recourse against the owner and his agent.
                            </Text>

                            </>

                        )}

                        

                        <View style={{marginTop:10}}/>
                        <Text style={styles.text}>
                            <Text style={{fontSize:20}}>L</Text>e PRENEUR prendra les lieux loués dans l’état où ils se trouveront au moment de l’entrée en
                                jouissance, et sans pouvoir exiger aucune réfection, remise en état, adjonction d’équipements
                                supplémentaires, ou travaux quelconques. Le PRENEUR devra jouir des lieux loués en bon père de
                                famille et l’occuper à titre exclusivement bourgeois c'est-à-dire à titre de résidence secondaire provisoire
                                (toute activité commerciale, industrielle et professionnelle est strictement prohibée). Le PRENEUR ne
                                devra pas modifier les lieux, la décoration ou la disposition du mobilier, et ne commettre de dégradations
                                et pertes survenues pendant le cours du bail par sa faute. Il doit également supporter les réparations
                                locatives ou de menu entretien sauf lorsqu'elles sont occasionnées par la vétusté ou la force majeure. Le
                                PRENEUR répond en outre de l'incendie des locaux loués (article 1733 du code civil et article 1734 du
                                code civil) à moins qu'il ne prouve que l'incendie est arrivé par cas fortuit (cause indéterminée), force
                                majeure, vice de construction ou qu'il a été communiqué par une maison voisine. Le PRENEUR doit
                                s’assurer que sa responsabilité est couverte par une assurance couvrant les risques locatifs. Le
                                PRENEUR ne pourra démonter les fenêtres et ou leurs encadrements, ainsi que les portes. Le
                                PRENEUR s’interdit de percer ou coller des éléments sur les murs. Le PRENEUR devra prendre toutes
                                les précautions pour, en aucune manière, troubler la jouissance paisible des voisins, le tout de façon que
                                le BAILLEUR ne puisse jamais être inquiété à ce sujet. Ainsi, il fera son affaire personnelle, à ses risques,
                                périls et frais, sans que le BAILLEUR puisse être impliqué ou recherché, de toutes réclamations faites par
                                les voisins ou les tiers, notamment pour bruits et/ou odeurs ou causés par lui, ses clients, son personnel,
                                ses fournisseurs et relations d'affaires, ou par des appareils lui appartenant. Le PRENEUR devra
                                s'engager à toujours maintenir constamment en état d'entretien, de fonctionnement, sécurité et propreté,
                                l'ensemble des locaux loués. Le PRENEUR devra s’abstenir de façon absolue de jeter dans les lavabos,
                                baignoires, bidets, éviers, lavoirs, etc…, des objets de nature à obstruer les canalisations, faute de quoi, il
                                sera redevable des frais occasionnés pour la remise en service de ces appareils. Le PRENEUR devra
                                veiller à ce que les meubles, tables, fauteuils et chaises de jardin soient revêtus de leurs housses de
                                protection après usage ou en cas d’intempéries, et remises, chaque soir ou en cas d’intempéries, dans le
                                local prévu à cet effet. Le PRENEUR ne devra pas introduire d’animaux tant à l’intérieur qu’à l’extérieur
                                de la Villa, étant précisé que les rondes de surveillance de nuit effectuées par du personnel de sécurité
                                accompagné de chiens de sécurité sont autorisées aux alentours de la villa. Le PRENEUR devra
                                autoriser des visites de la propriété dans le cadre de la vente les mardi et vendredi de chaque semaine de
                                14h à 17h, en respectant un délai de prévenance de 24 heures. Le PRENEUR devra faire son affaire
                                personnelle du gardiennage et de la surveillance des locaux, le BAILLEUR ne pouvant, en aucun cas, et à
                                aucun titre, être recherché et tenu pour responsable des vols ou détournements et autres actes
                                délictueux dont le PRENEUR pourrait être victime dans les locaux loués. Le PRENEUR devra renoncer à
                                tous recours en responsabilité contre le BAILLEUR en cas d'agissements générateurs de dommages de
                                son propre fait mais aussi de tous les occupants de l'immeuble, savoir notamment, son personnel, ses fournisseurs ou clients, et tous tiers en général, sans que le BAILLEUR puisse être inquiété ou poursuivi
                                de ce chef. Le PRENEUR s’oblige à laisser exécuter dans les lieux les travaux urgents nécessaires au
                                maintien en état des locaux loués et des éléments d’équipement commun, sans aucun recours contre le
                                BAILLEUR pour tout désagrément. En cas de perte des clefs, le BAILLEUR pourra exiger le
                                remplacement des serrures du logement, fixer le coût d’une éventuelle intervention par un spécialiste et
                                prélever le montant correspondant sur le sur le dépôt de garantie. Le PRENEUR devra immédiatement
                                informer le BAILLEUR ou son mandataire de toute anomalie constatée. Le PRENEUR devra effectuer
                                ou faire effectuer sous la responsabilité de l’agence Bo-House un ménage complet.
                        </Text>
                    </View>
                </View>
                <NbPage nb={'5/9'} />
            </View>
        </Page>
        <Page size="A4" style={styles.pageHome} > 
            <View style={styles.view} >
                <Image style={ { width: 100, marginLeft:'auto', marginRight:'auto'}} src={logo} />
                <View style={styles.section}>
                    <View style={styles.section}> 
                        <Text style={styles.texten}>
                            <Text style={{fontSize:20}}>T</Text>he TENANT will take the property in the state where they will be at the time of the taking possession,
                                and without being able to require any repair, restoration, addition of additional equipment, or any
                                works. The TENANT will have to enjoy places rented as a father and to occupy it to exclusively bourgeois
                                title that is as temporary holiday home (any commercial, industrial and professional activity is strictly
                                prohibited). The TENANT will not have to modify places, decoration or arrangement of the furniture, and
                                commit damages and losses arisen during the course of the lease by its fault. He also has to support the
                                renting repairs or of menu maintenance except when they are caused by the dilapidation or the force
                                majeure. The TENANT answers on top of the fire of rented places (article 1733 of the civil code and the
                                article 1734 of the civil code) unless he proves that the fire arrived by coincidence ( indefinite cause),
                                force majeure, construction fault or that he was communicated by a neighbouring house. The TENANT
                                has to make sure that its responsibility is covered by an insurance covering TENANT’S risks. The
                                TENANT cannot unsettle windows and or their frames, as well as doors. The TENANT refrains to drill or
                                to stick elements on walls. The TENANT will have to take all the precautions to disturb in no way the
                                peaceful enjoyment of the neighbors, the whole so that the LESSOR) can be never worried on this
                                matter. So, he will deal personally, at his risks, dangers and expenses, without the LESSOR can be
                                involved either looked for, of any complaints made by the neighbors or the thirds, in particular for noises
                                and/or smells or caused by him, his customers, his staff, his suppliers and business relationships, or by
                                devices belonging to him (her). The TENANT will have to make a commitment to maintain always
                                constantly in state of repair, of functioning, safety and cleanliness, the set of the rented premises. The
                                TENANT will have to refrain in a absolute way from throwing in washbasins, bathtubs, bidets, kitchen
                                sinks, wash houses, etc. …, objects likely to block pipes, otherwise, he will be indebted expenses caused
                                for the discount in service of these devices. The TENANT will have to watch that furnitures, tables,
                                armchairs and garden chairs are dressed in their covers of protection after use either in case of bad
                                weather, and put back, every evening or in case of bad weather, in the place planned for that purpose. The
                                TENANT will not have to introduce of animals so inside that outside of the Villa, being specified that the
                                rounds of night supervision made by the staff of security accompanied with dogs of security are
                                authorized near the villa. The TENANT will have to authorize visits of the property within the framework of
                                the sale on Tuesday and Friday of every week, from 2 pm to 5 pm, by respecting a deadline of kindness of
                                24 hours. The TENANT will have to deal personally with the guarding and with the supervision of places,
                                the LESSOR, in no way, be looked for and held responsible for the thefts or the misappropriations and
                                other criminal acts the TENANT could be a victim in the rented places. The TENANT will have to give up
                                any recourses in responsibility against the LESSOR in case of generative actions of damage by his/her
                                own act but also all the occupants of the building, knowledge in particular,his (her) staff, his (her)
                                suppliers or customers, and any thirds generally, without the LESSOR can be worried or pursued. The
                                TENANT obliges to let execute in places the urgent works necessary for the preservation in state of the
                                rented places and the elements of common equipment, without any recourse against the LESSOR for any
                                inconvenience. In case of loss of keys, the LESSOR can require the replacement of the locks of the
                                accommodation, fix the cost of a possible intervention by a specialist and take the amount corresponding
                                on the deposit. The TENANT will immediately have to inform the LESSOR or his representative of any
                                noticed anomaly. The TENANT will have to make or to perform under the responsibility of the agency Bo-
                                House a complete household.
                        </Text>
                    </View>
                </View>
                <NbPage nb={'6/9'} />
            </View>
        </Page>

        <Page size="A4" style={styles.pageHome} > 
            <View style={styles.view} >
                <Image style={ { width: 100, marginLeft:'auto', marginRight:'auto'}} src={logo} />
                <View style={styles.section}>
                    <View style={styles.section}> 
                        <Text style={styles.title}>
                        POLITIQUE D’ANNULATION
                        </Text>
                        <Text style={styles.titlen}>
                        CANCELLATION POLICY
                        </Text>
                        <View style={{marginTop:10}}/>
                        <Text style={styles.text}>
                            {/* <Text style={{fontSize:11}}>Pour toute annulation</Text> moins de 3 mois avant le début de la location, le montant total est dû par le PRENEUR.  */}


                            <Text>Pour toute annulation à plus de 3 mois avant le début de la location, le PRENEUR récupère son acompte.  

                            Pour toute annulation à moins de 3 mois avant le début de la location, Le BAILLEUR conservera l’acompte versé par le PRENEUR.  

                            Pour toute annulation à moins d’1 mois avant le début de la location, le PRENEUR doit au BAILLEUR la totalité du montant de la location. </Text>


                            <Text style={styles.texten}>
                            For any cancellation more than 3 months before the start of the rental, the TENANT recovers their deposit. For any cancellation less than 3 months before the start of the rental, the LESSOR will retain the deposit paid by the TENANT. For any cancellation less than 1 month before the start of the rental, the TENANT owes the LESSOR the entire amount of the rental.
                            </Text>
                        </Text>
                        <View style={{marginTop:10}}/>
                        <Text style={styles.title}>
                        ASSURANCES
                        </Text>
                        <Text style={styles.titlen}>
                        INSURANCES
                        </Text>
                        <View style={{marginTop:10}}/>
                        <Text style={styles.text}><Text style={{fontSize:20}}>L</Text><Text style={{fontSize:13}}>e BAILLEUR</Text> garantira les conséquences pécuniaires de la responsabilité civile qu’il peut encourir en
                        qualité d’agence immobilière. Le BAILLEUR s’assure que le Propriétaire garantira ses biens
                        immobiliers ainsi que tous les aménagements et installations de nature immobilières dont les locaux
                        seront dotés à la prise d’effet du bail et ce notamment contre les risques d’incendie, explosions, tempêtes
                        et dégâts des eaux.</Text>
                        <Text style={styles.texten}><Text style={{fontSize:20}}>T</Text><Text style={{fontSize:13}}>he LESSOR</Text> will guarantee the pecuniary consequences of the civil liability which he can incur as a
                        real estate. The LESSOR ensures that the owner will guarantee his real property as well as all the
                        arrangements and the real estate natural installations with which places will be endowed in the coming
                        into effect of the lease and it in particular against fire risks, explosions, storms and water damage.</Text>
                    
                        <View style={{marginTop:10}}/>
                        <Text style={styles.title}>
                        EFFETS DE FIN DE LOCATION
                        </Text>
                        <Text style={styles.titlen}>
                        END OF RENTAL
                        </Text>
                        <View style={{marginTop:10}}/>
                        <Text style={styles.text}><Text style={{fontSize:20}}>L</Text><Text style={{fontSize:13}}>e PRENEUR</Text> s’engage, à son départ, à restituer lesdits locaux, conformes à l’état des lieux et
                            inventaire des meubles de la Villa qui seront dressés contradictoirement à la prise de possession. Le
                            PRENEUR rendra les clés des locaux loués le jour de la fin de la période de location et un état
                            contradictoire des lieux ainsi qu’un inventaire de la Villa seront dressés.</Text>

                            <Text style={styles.texten}><Text style={{fontSize:20}}>T</Text><Text style={{fontSize:13}}>he TENANT</Text> makes a commitment, in its departure, to restore the aforementioned places,
                            corresponding to the current situation and the inventory of the furniture of the Villa which will be
                            contradictorily drawn up to the taking possession. The TENANT will return the keys of places rented the
                            day of the end of the period of rent and a contradictory state of places and an inventory of the Villa will be
                            raised.</Text>
                    
                        <View style={{marginTop:10}}/>

                        <Text style={styles.title}>
                        SOUS LOCATION ET CESSION PAR LE PRENEUR
                        </Text>
                        <Text style={styles.titlen}>
                        SUBLETTING AND TRANSFER BY THE TENANT
                        </Text>
                        <View style={{marginTop:10}}/>
                        <Text style={styles.text}>
                            <Text style={{fontSize:11}}>Le PRENEUR</Text> ne peut ni sous-louer les locaux ni céder son droit au présent bail sans autorisation écrite du BAILLEUR. <Text style={styles.texten}><Text style={{fontSize:11}}>The TENANT</Text> cannot either sublet places or transfer its right for the present lease without written authorization of the LESSOR.</Text>
                        </Text>
                        <View style={{marginTop:10}}/>
                        <Text style={styles.title}>
                        CLAUSE RESOLUTOIRE
                        </Text>
                        <Text style={styles.titlen}>
                        TERMINATION CLAUSE
                        </Text>
                        <View style={{marginTop:10}}/>
                        <Text style={styles.text}>
                            <Text style={{fontSize:20}}>À</Text>
                            <Text style={{fontSize: 11}}>défaut de paiement du loyer </Text>
                            ou des charges récupérables, de versement du dépôt de garantie, il est prévu que le bail sera résilié de plein droit.
                            <Text style={{fontSize: 11}}> À défaut de respect d’une des obligations du bail</Text>,
                            celui-ci sera résilié de plein droit. La présente clause résolutoire ne produira cependant effet que 5 (cinq)
                            jours après une mise en demeure (courrier recommandé avec accusé de réception) demeurée
                            infructueuse délai à l’issu duquel le présent contrat sera résilié et le solde dû par le PRENEUR.
                        </Text>

                        
                        

                    </View>
                </View>
                <NbPage nb={'7/9'} />
            </View>
        </Page>
        <Page size="A4" style={styles.pageHome} > 
            <View style={styles.view} >
                <Image style={ { width: 100, marginLeft:'auto', marginRight:'auto'}} src={logo} />
                <View style={styles.section}>
                    <View style={styles.section}> 

                    <Text style={styles.texten}>

                    <Text style={{fontSize:20}}>F</Text>
                            <Text style={{fontSize: 11}}>or lack of payment of the rent </Text>or the recoverable loads, the payment of the deposit, it is planned
                            that the lease will be cancelled by rights. 
                            <Text style={{fontSize: 11}}> For lack of respect for one of the obligations of the lease</Text>, this one will be cancelled by rights. The present cancellation clause will produce however effect
                            only 5 days after a formal demand (registered letter with acknowledgement of receipt) remained fruitless
                            deadline in the stemming from which the present contract will be cancelled and the balance will be due
                            by the TENANT.
                        
                        </Text>
                        <View style={{marginTop:10}}/>
                        <Text style={styles.title}>
                        ÉTAT DES LIEUX
                        </Text>
                        <Text style={styles.titlen}>
                        INVENTORY
                        </Text>
                        <View style={{marginTop:10}}/>
                        <Text style={styles.text}>
                            <Text style={{fontSize:20}}>U</Text><Text style={{fontSize: 11}}>n état des lieux</Text>
                            des locaux et des extérieurs de même qu’un inventaire du mobilier seront dressés
                            par le personnel affilié a la Villa (ou par un huissier de justice), le premier et le dernier jour de prise
                            de possession, ou si elles le désirent par les parties entre elles mais impérativement de manière
                            contradictoire.
                        </Text>


                        <Text style={styles.texten}>
                            <Text style={{fontSize:20}}>A</Text><Text style={{fontSize: 11}}>n inventory of fixtures</Text>
                            of places and outsides as well as an inventory of the furniture will be drawn
                            up by affiliated staff (or by a bailiff) the first one and the last day of taking possession, or if they wish,
                            by the parts between them but necessarily in a contradictory way.
                        </Text>
                        <View style={{marginTop:10}}/>
                        <Text style={styles.title}>
                        ÉTAT DES RISQUES NATURELS ET TECHNOLOGIQUES
                        </Text>
                        <Text style={styles.titlen}>
                        STATE OF NATURAL AND TECHNOLOGICAL RISKS
                        </Text>
                        <View style={{marginTop:10}}/>

                        <Text style={styles.text}>
                            <Text style={{fontSize:20}}>L</Text><Text style={{fontSize: 11}}>es biens </Text>
                            ainsi que la propriété du présent Mandat, sont situés dans une zone couverte par un plan de
                            prévention des risques technologiques, prescrit ou approuvé, ou par un plan de prévention des risques
                            naturels prévisibles, prescrit ou approuvé, ou dans une zone de sismicité définie par Décret en conseil
                            d’Etat.
                        </Text>


                        <Text style={styles.texten}>
                            <Text style={{fontSize:20}}>T</Text><Text style={{fontSize: 11}}>he property </Text>
                            as well as the property of the present Mandate, are located in an area covered by a plan
                            for the prevention of technological risks, prescribed or approved, or by a plan for the prevention of
                            foreseeable natural risks, prescribed or approved, or in a seismicity zone defined by Decree in Council of
                            State.
                        </Text>

                        <View style={{marginTop:10}}/>
                        <Text style={styles.title}>
                        LOI APPLICABLE ET ATTRIBUTION DE COMPETENCE
                        </Text>
                        <Text style={styles.titlen}>
                        APPLICABLE LAW AND CHOICE OF JURISDICTION
                        </Text>
                        <View style={{marginTop:10}}/>
                        <Text style={styles.text}>
                            <Text style={{fontSize: 11}}>La présente location</Text>
                            rédigée en langue française et traduite en anglais, est régie par la loi française. En
                            cas de litige, le Tribunal compétent sera celui dans le ressort duquel est situé le lieu de l’immeuble.
                            <Text style={styles.texten}>
                                <Text style={{fontSize: 11}}>This rental</Text>
                                written in French and translated into English, is governed by French law. In case of dispute, the competent court will be the one in whose jurisdiction the place of the building is located.
                        </Text>
                        </Text>

                        <View style={{marginTop:10}}/>
                        <Text style={styles.title}>
                        ELECTION DE DOMICILE
                        </Text>
                        <Text style={styles.titlen}>
                        CHOICE OF RESIDENCE
                        </Text>
                        <View style={{marginTop:10}}/>
                        <Text style={styles.text}>
                        Pour l’exécution des présentes et de leurs suites et de toute notification qui s’avérerait nécessaire les parties élisent domicile :
                        </Text>
                        <Text style={styles.text}>• Pour le BAILLEUR, en son siège social</Text>
                        <Text style={styles.text}>• Pour le PRENEUR, à son domicile</Text>

                        <Text style={styles.texten}>
                        For the execution of the present one and their consequences and any notification which would turn out to be necessary the parts take up residence:</Text>
                        <Text style={styles.texten}>• For the LESSOR, in his head office</Text>
                        <Text style={styles.texten}>• For the TENANT, in its place of residence</Text>



                                    
                    </View>
                </View>
                <NbPage nb={'8/9'} />
            </View>
        </Page>

        <Page size="A4" style={styles.pageHome} > 
            <View style={styles.view} >
                <Image style={ { width: 100, marginLeft:'auto', marginRight:'auto'}} src={logo} />
                <View style={styles.section}>
                    <View style={styles.section}>  
                        <Text style={styles.text}>FAIT À SAINT-TROPEZ, <Text style={{backgroundColor:'black', color:'white'}}>LE {contract && contract?.sign ? moment(contract?.sign?.date?.toDate()).format('DD/MM/YYYY') : '--/--/----'}</Text></Text> 
                        <Text style={styles.text}>MADE AT SAINT-TROPEZ, <Text style={{backgroundColor:'#5e5e5e', color:'white'}}>ON THE {contract && contract?.sign ? moment(contract?.sign?.date?.toDate()).format('DD/MM/YYYY') : '--/--/----'}</Text></Text>
                    
                        <View style={{marginTop:30}}/>
                        <View style={{display:'flex', flexDirection:'row',}}>
                            <View style={{flex:1}}>
                                <Text style={[styles.text, {fontSize: 11}]}>LE PRENEUR</Text>
                                <Text style={[styles.texten, {fontSize: 11}]}>THE TENANT</Text>
                                <Text style={[styles.text, {fontSize: 11}]}>« Lu et approuvé »</Text>
                                <Text style={[styles.texten, {fontSize: 11}]}>"Read and approved"</Text>
                                {contract && contract?.sign && (
                                     <Image style={ { width: 100}} src={contract?.sign?.bURL64} />
                                )}
                                <Text style={[styles.text, { paddingLeft: 100, paddingTop:10}]}>{getUser(contract?.client?.value)?.signature}</Text>
                            </View>
                            <View style={{flex:1}}>
                                <Text style={[styles.text, {fontSize: 11}]}>LE BAILLEUR</Text>
                                <Text style={[styles.texten, {fontSize: 11}]}>THE LESSOR</Text>
                                <Text style={[styles.text, {fontSize: 11}]}>« Lu et approuvé »</Text>
                                <Text style={[styles.texten, {fontSize: 11}]}>"Read and approved"</Text>
                                {contract && contract?.sign && contract?.sign?.bohouse && (
                                    <Image style={ { width: 100}} src={signbohouse} />
                                )}
                                <Text style={[styles.text, { paddingLeft: 100, paddingTop:10}]}>Lu et approuvé</Text>
                            </View>
                        </View>

                                    
                    </View>
                </View>
                <NbPage nb={'9/9'} />
            </View>
        </Page>

        <Page size="A4" style={styles.pageHome} > 
            <View style={styles.view} >
                <Image style={ { width: 100, marginLeft:'auto', marginRight:'auto'}} src={logo} />
                <View style={styles.section}>
                    <Text style={[styles.textd, {fontFamily:'Cormorant'}]}>ÉTAT DESCRIPTIF</Text>
                    <Text style={[styles.textd, {color:'#5e5e5e', fontFamily:'Cormorant'}]}>DESCRIPTIVE STATEMENT</Text>
                    <View style={styles.section}> 
                        <View style={{marginTop:10}}/>
                        <View style={{border:'1px solid #d5d5d5' }}>
                            <Ligne fr={'ADRESSE DU LIEU LOUÉ'} en={'ADDRESS OF THE RENTED PLACE'} info={`${getVilla(contract?.property?.value)?.data?.adresse} ${getVilla(contract?.property?.value)?.data?.zipcode} ${getVilla(contract?.property?.value)?.data?.city}`} bt={true} t={2}  /> 
                            <Ligne fr={'QUARTIER DE LA LOCATION'} en={'RENTAL AREA'} info={getVilla(contract?.property?.value)?.data?.quartier || '--'} t={2} bg={true}   />
                            <Ligne fr={'CAPACITÉ D’OCCUPATION'} en={'OCCUPANCY CAPACITY'} info={`${getVilla(contract?.property?.value)?.data?.maxGuest || '--'} personnes`} t={2}    bt={true}/>
                            <Ligne fr={'TYPE DE LOGEMENT'} en={'TYPE OF ACCOMMODATION'} info={`${getVilla(contract?.property?.value)?.data?.type?.label || "---"}`} t={2} bg={true}  />
                            <Ligne fr={'SURFACE HABITABLE'} en={'LIVING AREA'} info={`${getVilla(contract?.property?.value)?.data?.m2habitable || "---"} m2`} t={2}  bt={true}/>
                            <Ligne fr={'EXPOSITION'} en={'EXHIBITION'} info={`${getVilla(contract?.property?.value)?.data?.exposition  || '---'}`} t={2} bg={true}   />
                            <Ligne fr={'DÉTAIL DES PIÈCES'} en={'DETAILS OF THE PARTS'} info={getVilla(contract?.property?.value)?.data?.detailpiece || "---"} t={2}   bt={true}/>
                            <Ligne fr={'DÉTAIL DES ÉQUIPEMENTS'} en={'EQUIPMENT DETAILS'} info={`Équipé`} t={2} bg={true}   />
                            <Ligne fr={'LINGE DE MAISON'} en={'HOUSEHOLD LINEN'} info="Inclus" t={2}    bt={true}/>
                            <Ligne fr={'CHAUFFAGE'} en={'HEATING'} info={`Général`} t={2} bg={true}   />
                            <Ligne fr={'CHARGES COMPRISES'} en={'CHARGES INCLUDED'} info="TTC" t={2}   bt={true}/>
                            <Ligne fr={'CHARGES NON COMPRISES'} en={'CHARGES NOT INCLUDED'} info={`NC`} t={2} bg={true}   />
                            <Ligne fr={'DÉTAIL DES ANNEXES pouvant être utilisées par le PRENEUR'} en={'DETAILS OF THE ANNEXES that can be used by the TENANT'} info="Totalité des installations. The whole Installation." t={2}   bt={true}/>
                            <Ligne fr={'DISTANCE DE LA LOCATION par rapport aux principaux équipements et centres d’intérêt'} en={'DISTANCE OF THE RENTAL from the main facilities and points of interest'} info={getVilla(contract?.property?.value)?.data?.distance || '--'} t={2} bg={true}   />
                        </View>
                    </View>
                </View> 
            </View>
        </Page>
  
    </Document>
  )
 
  return (
    <div style={{
        clear: "both", 
        overflow: "hidden"
    }}>
        <PDFViewer>
            <MyDocument />
        </PDFViewer>
    </div>
  );
};

export default ContractPDF;
